import React from "react";
import { motion } from "framer-motion";
import { FileWarning, HeartPulse, MessagesSquare, Dumbbell } from "lucide-react";

const items = [
  { icon: FileWarning, title: "Generic Resume", body: "Using the same resume for every role reduces relevance and can affect ATS screening." },
  { icon: HeartPulse, title: "Interview Anxiety", body: "Candidates often know what they want to say but struggle to communicate it confidently." },
  { icon: MessagesSquare, title: "Communication Gap", body: "Weak professional communication can affect first impressions and interview performance." },
  { icon: Dumbbell, title: "Lack of Practice", body: "Candidates who have never experienced realistic mock interviews often enter actual interviews unprepared." },
];

export default function Problem() {
  return (
    <section id="problem" className="py-24 sm:py-32 bg-white">
      <div className="max-w-7xl mx-auto px-5 sm:px-8">
        <div className="max-w-3xl">
          <div className="text-xs tracking-[0.28em] uppercase text-slate-500">The Gap</div>
          <h2 className="mt-3 font-display text-3xl sm:text-5xl leading-tight text-[#0B132B]">Why Qualified Candidates Still Struggle to Get Hired</h2>
          <p className="mt-5 text-slate-600 text-base sm:text-lg leading-relaxed">
            A degree may make someone eligible for an opportunity, but employers evaluate much more than qualifications.
            Communication, confidence, resume relevance, interview performance and professional presentation often determine who moves forward.
          </p>
        </div>
        <div className="mt-12 grid gap-5 sm:grid-cols-2 lg:grid-cols-4">
          {items.map((it, i) => (
            <motion.div key={it.title}
                        initial={{ opacity: 0, y: 16 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }}
                        transition={{ delay: i * 0.08 }}
                        className="group relative rounded-2xl bg-white ring-1 ring-slate-100 p-6 hover:-translate-y-1 hover:shadow-elev transition-transform">
              <div className="h-11 w-11 rounded-xl bg-[#0B132B] text-white grid place-items-center mb-5 group-hover:rotate-3 transition-transform">
                <it.icon size={18} />
              </div>
              <div className="font-display text-lg font-medium text-[#0B132B]">{it.title}</div>
              <p className="mt-2 text-sm text-slate-600 leading-relaxed">{it.body}</p>
              <div className="mt-6 h-px bg-gradient-to-r from-slate-200 to-transparent" />
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
